/**
 * Utility functions for handling question types consistently across the application
 */

/**
 * Converts any question type format to the internal standardized format
 * @param {string} type - The question type from the database/API
 * @returns {string} - The internal standardized question type
 */
export const getInternalType = (type) => {
  switch (type) {
    case "Short Answer":
    case "short_answer":
      return "short_answer";
    case "Paragraph":
    case "paragraph":
      return "paragraph";
    case "Single Selection":
    case "single_selection":
    case "Multiple Choice":
    case "multiple_choice":
      return "multiple_choice";
    case "Multiple Selection":
    case "multiple_selection":
    case "Checkbox":
    case "checkbox":
      return "checkbox";
    case "Date":
    case "date":
      return "date";
    case "Time":
    case "time":
      return "time";
    case "Dropdown":
    case "dropdown":
      return "dropdown";
      case "File Input":
        case "file":
        case "file_input":
          return "file";
    default:
      return type?.toLowerCase() || "short_answer";
  }
};

/**
 * Checks if a question type is eligible to be a primary question in a group
 * @param {string} type - The question type
 * @returns {boolean} - True if the question type can be a primary question
 */
export const isPrimaryQuestionEligible = (type) => {
  const internalType = getInternalType(type);
  return internalType === "multiple_choice" || internalType === "checkbox";
};

/**
 * Gets the display name for a question type
 * @param {string} type - The internal question type
 * @returns {string} - The display name for the question type
 */
export const getQuestionTypeDisplayName = (type) => {
  switch (type) {
    case "short_answer":
      return "Short Answer";
    case "paragraph":
      return "Paragraph";
    case "multiple_choice":
      return "Single Selection";
    case "checkbox":
      return "Multiple Selection";
    case "date":
      return "Date";
    case "time":
      return "Time";
    case "dropdown":
      return "Dropdown";
    default:
      return type;
  }
};
